import { Lang, LocalizedPath } from '@domain/language-negotiation';
import { localizedPath } from '@utils/localized-path';

// langCodeToLocalizedPath :: Lang -> LocalizedPath
export const langCodeToLocalizedPath = (langCode: Lang): LocalizedPath =>
  localizedPath(location.pathname, langCode, location.search, location.hash);
